module.exports = __webpack_public_path__ + "img/New PACI Flow - New-8.9c5bb33c.png";